import { Events, emit } from './events.js';
import { BaseInteractiveElement } from './component-base.js';

// Extend BaseInteractiveElement for DRY interactions and analytics wiring
class ProductCardElement extends BaseInteractiveElement {
  constructor() {
    super({ baseClass: 'product-card', eventGroup: Events.card });
    // Note: For now we reuse Events.card; later we can add Events.productCard
  }
}

try {
  const TAG = 'product-card';
  if (!customElements.get(TAG)) customElements.define(TAG, ProductCardElement);
} catch (e) {}


